export enum LastActiveFilterEnum {
  Today = "today",
  Week = "week",
  Month = "month",
  Inactive30Plus = "inactive30",
  Never = "never",
}
